import styled from 'styled-components'

const RoznicaCITRZiSExpandableRowStyle = styled.div`
  padding: 12px 0px 12px 0px;
  border-radius: 4px;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  margin-bottom: 4px;

  &.expanded {
    padding-bottom: 2px;
  }

  :hover {
    box-shadow: -5px 0px 0px 0px ${props => props.theme.palette.primary.main};
  }

  .content-header {
    width: 100%;
    height: 36px;
    background: ${props => props.theme.black4onBlack4};
    padding: 12px 20px 10px;
    font-family: 'Ubuntu';
    font-size: 11px;
    color: ${props => props.theme.black38};
    margin: 12px 0;

    p {
      margin: 0;
    }
  }

  .name {
    grid-area: name;
    display: flex;
    align-items: center;
  }

  .from {
    grid-area: from;
    text-align: right;
  }

  .to {
    grid-area: to;
    text-align: right;
  }

  .roznica-row {
    padding: 0 8px 0 20px;
  }

  .content {
    > .roznica-row {
      padding: 1px 8px 18px 20px;
      .name {
        padding-left: 16px;
      }
    }
  }
`

export default RoznicaCITRZiSExpandableRowStyle
